import { jsx } from 'react/jsx-runtime';
import { Box } from '@vp/swan';

const TemplateTilePricing = ({ children }) => /* @__PURE__ */ jsx(Box, { mb: 4, children });

export { TemplateTilePricing };
